import { PageHeader } from '@/components/PageHeader';
import { EmptyState } from '@/components/EmptyState';
import { DataTable } from '@/components/DataTable';
import { StatusBadge } from '@/components/StatusBadge';
import { useInvoices } from '@/hooks/useDesk';
import { formatDate, formatNadFromCents } from '@/lib/format';

export function InvoicesPage() {
  const { data, isLoading, isError, error } = useInvoices();

  return (
    <div>
      <PageHeader
        title="Invoices"
        description="Invoices issued from quotes."
      />
      {isLoading ? (
        <p className="animate-pulse-soft text-sm text-[var(--muted)]">Loading…</p>
      ) : null}
      {isError ? (
        <p className="text-sm text-dome-danger">{(error as Error).message}</p>
      ) : null}
      {!isLoading && data && data.length === 0 ? (
        <EmptyState
          title="No invoices yet"
          body="Issue an invoice from an accepted or draft quote on the Quotes page."
        />
      ) : null}
      {data && data.length > 0 ? (
        <DataTable
          headers={['Number', 'Client', 'Event', 'Total', 'Status', 'Due']}
        >
          {data.map((row) => (
            <tr key={row.id}>
              <td className="px-3 py-2 font-mono text-xs">
                {row.invoice_number}
              </td>
              <td className="px-3 py-2">
                {row.domeec_clients?.company_name || '—'}
              </td>
              <td className="px-3 py-2">{row.domeec_events?.name || '—'}</td>
              <td className="px-3 py-2">
                {formatNadFromCents(row.total_cents)}
              </td>
              <td className="px-3 py-2">
                <StatusBadge status={row.status} />
              </td>
              <td className="px-3 py-2">{formatDate(row.due_at)}</td>
            </tr>
          ))}
        </DataTable>
      ) : null}
    </div>
  );
}
